import { Button, Input } from "@material-tailwind/react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function ResetPage() {
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();


	const submit = async (e) => {
		e.preventDefault();
		try {
			const { data } = await axios.get(
				`${process.env.REACT_APP_RELAY_API_HOST}/reset-password?username=${encodeURIComponent(email)}&usertype=SUPER_ADMIN`,
			);
			if (!data.success) {
				if (data.message) throw new Error(data.message);
				throw new Error("Reset failed");
			}
			navigate(`/confirm-password-reset/${encodeURIComponent(email)}`);
		} catch (err: any) {
			if (err?.response?.status === 404) {
				setError("Password reset request failed: User not found");
				setTimeout(() => setError(""), 2000);
				return;
			}
			console.error(err);
			setError(`Password reset request failed: ${err}`);
			setTimeout(() => setError(""), 2000);
		}
	};

	return (
		<div className="flex flex-col justify-center px-6 lg:px-8 mt-36">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
					Password reset
				</h2>
			</div>

			<div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm">
				<form onSubmit={submit} className="space-y-6">
					<div>
						<div className="mt-2">
							<Input
								label="Account email"
								crossOrigin=""
								type="text"
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
						</div>
					</div>

					<div>
						<Button
							type="submit"
							className="flex w-full justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-800"
						>
							Reset
						</Button>

						{error && (
							<p className="text-center text-sm text-red-500 mt-4">{error}</p>
						)}
					</div>
				</form>
			</div>
		</div>
	);
}
